/**
 * Single import surface for widget-side configuration.
 *
 * Production embeds set `api-endpoint`, `client-id`, and `username` as
 * HTML attributes on <netwatch-widget> — the values here are only for
 * the dev test page (widget/index.html) and any other tooling that
 * stands the widget up without explicit attributes.
 *
 * Sources:
 *   - VITE_API_ENDPOINT   → widget/.env           (committed default)
 *   - VITE_DEV_CLIENT_ID  → widget/.env.local     (per-developer)
 *   - VITE_DEV_USERNAME   → widget/.env.local     (per-developer)
 */

const env = import.meta.env

export const API_ENDPOINT = env.VITE_API_ENDPOINT || 'http://localhost:8000'

// Dev-page-only fillers. Production sets these via HTML attributes. The
// client id stays empty (must be supplied per-developer via .env.local);
// the username defaults to "dev" so the local test page works out of the box.
export const DEV_CLIENT_ID = env.VITE_DEV_CLIENT_ID || ''
export const DEV_USERNAME = env.VITE_DEV_USERNAME || 'dev'

// Build-time kill switch for the Outlook insight tile's "Ask NetWatch →"
// chat link. The production publish bakes VITE_INSIGHT_ASK_ENABLED=0 until
// the insight→chat path is exhaustively tested; unset/anything else = shown.
export const INSIGHT_ASK_ENABLED = env.VITE_INSIGHT_ASK_ENABLED !== '0'
